import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload
    },
    updateUserStatus: (state, action) => {
      if (!state.data) return
      const status =
        typeof action.payload === "string"
          ? action.payload
          : action.payload?.status
      if (!status) return
      state.data.userStatus = status
      const apply = (dev) =>
        dev
          ? {
              ...dev,
              userStatus: { ...(dev.userStatus || {}), status },
            }
          : dev
      if (Array.isArray(state.data.deviceData)) {
        if (state.data.deviceData[0]) {
          state.data.deviceData[0] = apply(state.data.deviceData[0])
        }
      } else if (state.data.deviceData) {
        state.data.deviceData = apply(state.data.deviceData)
      }
    },
  },
})

export const { setUser,updateUserStatus } = userSlice.actions
export default userSlice.reducer
